import axiosInstance from "@js-app/services/http/axios-instance";
class AnalyticsApi {
  async getCurrencies(companyId, filters) {
    return (
      await axiosInstance.post(`/companies/${companyId}/analytics/currencies`, {
        ...filters,
      })
    ).data;
  }

  async getMids(companyId) {
    return (await axiosInstance.get(`/companies/${companyId}/analytics/mids`))
      .data;
  }
}

export default new AnalyticsApi();
